export enum ExpenditureControlNamesEnum {
  CHILD_DEPENDANTS_COUNT = 'childDependantsCount',
  ADULT_DEPENDANTS_COUNT = 'adultDependantsCount',

  NUMBER_OF_CHILD_DEPENDANTS = 'numberOfChildDependants',
  NUMBER_OF_ADULT_DEPENDANTS = 'numberOfAdultDependants',

  COUNCIL_TAX = 'councilTax',
  GROUND_RENT_AND_SERVICE_CHARGE = 'groundRentAndServiceCharge',

  FURNISHING_AND_PROPERTY_MAINTENANCE = 'furnishingAndPropertyMaintenance',

  SCHOOL_NURSERY_AND_CHILDCARE_FEES = 'schoolNurseryAndChildcareFees',
  ALIMONY_AND_CHILD_MAINTENANCE = 'alimonyAndChildMaintenance'
}
